//import { storableError } from '../util/errors';
//import * as log from '../util/log';
import { fetchCurrentUser } from '../../ducks/user.duck';

import * as log from '../../util/log';
import { storableError } from '../../util/errors';

// =======================================
// Action types
// =======================================

export const GENERATE_CERTIFICATE_REQUEST = 'app/certificate/GENERATE_CERTIFICATE_REQUEST';
export const GENERATE_CERTIFICATE_SUCCESS = 'app/certificate/GENERATE_CERTIFICATE_SUCCESS';
export const GENERATE_CERTIFICATE_ERROR = 'app/certificate/GENERATE_CERTIFICATE_ERROR';

export const UPLOAD_CERTIFICATE_REQUEST = 'app/certificate/UPLOAD_CERTIFICATE_REQUEST';
export const UPLOAD_CERTIFICATE_SUCCESS = 'app/certificate/UPLOAD_CERTIFICATE_SUCCESS';
export const UPLOAD_CERTIFICATE_ERROR = 'app/certificate/UPLOAD_CERTIFICATE_ERROR';

export const CLEAR_CERTIFICATE_ERROR = 'app/certificate/CLEAR_CERTIFICATE_ERROR';

export const SET_EXISTING_CERTIFICATE = 'app/CensoPage/SET_EXISTING_CERTIFICATE';

export const SAVE_CENSO_DATA_REQUEST = 'app/CensoPage/SAVE_CENSO_DATA_REQUEST';
export const SAVE_CENSO_DATA_SUCCESS = 'app/CensoPage/SAVE_CENSO_DATA_SUCCESS';
export const SAVE_CENSO_DATA_ERROR = 'app/CensoPage/SAVE_CENSO_DATA_ERROR';

// =======================================
// Reducer
// =======================================

const initialState = {
  generateInProgress: false,
  uploadInProgress: false,
  certificateUrl: null,
  certificateImageId: null,
  generateError: null,
  uploadError: null,
  saveCensoInProgress: false,
  saveCensoError: null,
  censoDataSaved: false,
};

export default function certificateReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case GENERATE_CERTIFICATE_REQUEST:
        return {
            ...state,
            generateInProgress: true,
            generateError: null,
        };

    case GENERATE_CERTIFICATE_SUCCESS:
        return {
            ...state,
            generateInProgress: false,
        };

    case GENERATE_CERTIFICATE_ERROR:
        return {
            ...state,
            generateInProgress: false,
            generateError: payload,
        };

    case UPLOAD_CERTIFICATE_REQUEST:
        return {
            ...state,
            uploadInProgress: true,
            uploadError: null,
        };

    case UPLOAD_CERTIFICATE_SUCCESS:
        return {
            ...state,
            uploadInProgress: false,
            certificateUrl: payload.certificateUrl,
            certificateImageId: payload.certificateImageId,
        };

    case UPLOAD_CERTIFICATE_ERROR:
        return {
            ...state,
            uploadInProgress: false,
            uploadError: payload,
        };

    case CLEAR_CERTIFICATE_ERROR:
        //console.log('CLEAR_CERTIFICATE_ERROR Limpiando errores de certificado');
        return {
            ...state,
            generateError: null,
            uploadError: null,
        };

    case SET_EXISTING_CERTIFICATE:
        return {
            ...state,
            certificateUrl: payload.certificateUrl,
            certificateImageId: payload.certificateImageId,
            generateInProgress: false,
            uploadInProgress: false,
            generateError: null,
            uploadError: null,
        };
      
    case SAVE_CENSO_DATA_REQUEST:
        return {
            ...state,
            saveCensoInProgress: true,
            saveCensoError: null,
        };

    case SAVE_CENSO_DATA_SUCCESS:
        return {
            ...state,
            saveCensoInProgress: false,
            censoDataSaved: true,
        };

    case SAVE_CENSO_DATA_ERROR:
        return {
            ...state,
            saveCensoInProgress: false,
            saveCensoError: payload,
        };

    default:
      return state;
  }
}

// =======================================
// Action creators
// =======================================

export const setExistingCertificate = (certificateUrl, certificateImageId) => ({
    type: SET_EXISTING_CERTIFICATE,
    payload: { certificateUrl, certificateImageId },
});

export const generateCertificateRequest = () => ({
  type: GENERATE_CERTIFICATE_REQUEST,
});

export const generateCertificateSuccess = () => ({
  type: GENERATE_CERTIFICATE_SUCCESS,
});

export const generateCertificateError = error => ({
  type: GENERATE_CERTIFICATE_ERROR,
  payload: error,
  error: true,
});

export const uploadCertificateRequest = () => ({
  type: UPLOAD_CERTIFICATE_REQUEST,
});

export const uploadCertificateSuccess = (certificateUrl, certificateImageId) => ({
  type: UPLOAD_CERTIFICATE_SUCCESS,
  payload: { certificateUrl, certificateImageId },
});

export const uploadCertificateError = error => ({
  type: UPLOAD_CERTIFICATE_ERROR,
  payload: error,
  error: true,
});

export const clearCertificateError = () => ({
  type: CLEAR_CERTIFICATE_ERROR,
});

export const saveCensoDataRequest = () => ({
  type: SAVE_CENSO_DATA_REQUEST,
});

export const saveCensoDataSuccess = () => ({
  type: SAVE_CENSO_DATA_SUCCESS,
});

export const saveCensoDataError = error => ({
  type: SAVE_CENSO_DATA_ERROR,
  payload: error,
  error: true,
});

// =======================================
// Thunks
// =======================================

/**
 * Genera y sube el certificado a Sharetribe
 */




export const generateAndUploadCertificate = (certificateBlob, userId) => async (
  dispatch,
  getState,
  sdk
) => {

  //console.log("generateAndUploadCertificate 1")
  dispatch(generateCertificateRequest());
  dispatch(uploadCertificateRequest());
  //console.log("generateAndUploadCertificate 2")
  try {

    const queryParams = {
      expand: true,
      'fields.image': [
        'variants.default',
        'variants.landscape-crop',
        'variants.landscape-crop2x',
      ],
    };

    const uploadResponse = await sdk.images.upload(
      { image: certificateBlob },
      queryParams
    );

    const imageData = uploadResponse.data.data;

    const imageId = imageData.id.uuid;
    const imageUrl = 
      imageData.attributes?.variants?.default?.url || 
      imageData.attributes?.url;

    if (!imageUrl) {
      throw new Error('No se pudo obtener la URL de la imagen');
    }
    //console.log("Imagen subida correctamente. ID:", imageId, "URL:", imageUrl);
    try {
      //console.log("profileUpdateResponse: trye")
      const profileUpdateResponse = await sdk.currentUser.updateProfile({
        publicData: {
          censoCertificate: {
            imageUrl,
            imageId,
            generatedAt: new Date().toISOString(),
            userId: userId,
            version: process.env.REACT_APP_CENSO_CERTIFICATE_VERSION_AR,
          },
        },
      });
      //console.log("profileUpdateResponse: ", profileUpdateResponse)
      await dispatch(fetchCurrentUser());
      
    } catch (profileError) {
      throw profileError; 
    }

    dispatch(uploadCertificateSuccess(imageUrl, imageId));
    dispatch(generateCertificateSuccess());

    return { imageUrl, imageId, imageData };
    
  } catch (error) {
    
    const storedError = storableError(error);
    dispatch(generateCertificateError(storedError));
    dispatch(uploadCertificateError(storedError));
    
    throw error;
  }
};

/**
 * Guarda los datos del censo en privateData del usuario
 * @param {Object} censoData - Datos del formulario del censo
 * @param {string} supabaseCensoId - ID del registro en Supabase
 */

export const saveCensoDataToProfile = (censoData, data, supabaseCensoId) => async (
  dispatch,
  getState,
  sdk
) => {
  dispatch(saveCensoDataRequest());

  try {

    const censoPrivateData = {
      censoCompleted: true,
      censoCompletedAt: new Date().toISOString(),
      supabaseCensoId, 
      censoData: {
        fechaNacimiento: data.censo.fecha_nacimiento,
        documento: data.censo.documento,
        provincia: data.censo.provincia_nombre,
        localidad: data.censo.localidad_nombre,
        //cantidadPersonas: censoData.cantidadPersonas,
        composicionGrupo: data.censo.composicion_grupo,
        composicionGrupoOtro: data.censo.composicion_grupo_otro,
        queTenes: data.censo.que_tenes,
        tieneVehiculos: data.censo.tiene_vehiculos,
        enQueViajas: data.censo.en_que_viajas,
        vehiculos: data.vehiculos.map(v => ({
          patente: v.patente.replace(/[^A-Za-z0-9]/g, '').toUpperCase(),
          tipo: v.tipo,
          marca: v.marca,
          modelo: v.modelo,
          marcaOtro: v.marca_otro, //v.marca === 'otro' ? v.marcaOtro : v.marca,
          modeloOtro: v.modelo_otro, //v.modelo === 'otro' ? v.modeloOtro : v.modelo,
          año: v.año,
          plazasDormir: v.plazas_dormir,
        })),
        
        usoVehiculo: data.censo.uso_vehiculo,
        kilometrosAnuales: data.censo.kilometros_anuales,
        lugaresPernocta: data.censo.lugares_pernocta,
        conoceReglamentoParques: data.censo.conoce_reglamento_parques,
        zonasRecorridas: data.censo.zonas_recorridas,
        zonasRecorridasOtro: data.censo.zonas_recorridas_otro,
        dificultadesViaje: data.censo.dificultades_viaje,
        dificultadesViajeOtro: data.censo.dificultades_viaje_otro,
        serviciosIndispensables: data.censo.servicios_indispensables,
        serviciosIndispensablesOtro: data.censo.servicios_indispensables_otro,
      },
    };

    const profileUpdateResponse = await sdk.currentUser.updateProfile({
      privateData: {
        censo: censoPrivateData,
      },
    });

    await dispatch(fetchCurrentUser());

    dispatch(saveCensoDataSuccess());
    return profileUpdateResponse.data;
    
  } catch (error) {
    
    const storedError = storableError(error);
    dispatch(saveCensoDataError(storedError));
    
    throw error;
  }
};